import { VariableValueForm } from '../components/DashboardShow/components/Content/DashboardFilters/variableValueForm'
import { Variable, variableValueToBackend } from '../store/models/Report'

const buildVariablesForms = (variables: Variable[]) =>
  variables.map((variable) => {
    const defaultValue = variable.default_value
      ? variableValueToBackend(variable.type, variable.default_value)
      : undefined
    const value = variable.value ? variableValueToBackend(variable.type, variable.value) : undefined

    return new VariableValueForm({
      ...variable,
      default_value: defaultValue,
      value: value || defaultValue,
    })
  })

export default buildVariablesForms
